export enum TicketAction {
    View = 1,
    Close = 2,
    Reopen = 3,
    Resolve = 4
}

export enum Filter {
    Assigned = 1,
    Center = 2,
    Type = 3,
    Status = 4,
    Tier = 5,
    Group = 6,
    Search = 7,
    SearchBy = 70,
    Urgency = 8,
    StartDate = 9,
    EndDate = 10,
    Tags = 11
}